
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-dept-picker-config",
})
export default class DeptPickerConfig extends ComponentConfigMixins {}
